import { useMemo } from 'react';
import { useCharacteristicsGetAll } from '../../api';

export const useFilterCharacteristicTitleByValue = (values: string[]): { value: string; title: string }[] => {
    const { data } = useCharacteristicsGetAll({});

    return useMemo(
        () =>
            values.map((value) => {
                return {
                    value,
                    title: data?.find((characteristic) => characteristic.slug === value)?.title ?? value,
                };
            }),
        [data, values]
    );
};
